<template>
    <button @click="list" type="button" class="btn btn-sm btn-secondary mr-1">
        <font-awesome-icon icon="list"/>&nbsp;{{$t('numbers')}}
        <b-modal size="lg" v-model="showList" :title="$t('numbers')" ok-only no-close-on-backdrop no-enforce-focus>
            <number-list :host="host" :client="client"></number-list>
        </b-modal>
    </button>
</template>
<script>
    import NumberList from "./NumberList";
    export default {
        props:{
            host: Object,
            client: Object
        },
        components: {NumberList},
        data() {
            return {
                showList: false,
            }
        },
        methods:{
            list() {
                this.showList = true;
            }
        },
        i18n: {
            messages: {
                en: {
                    numbers: 'Phone numbers'
                },
                vi: {
                    numbers: 'Số điện thoại'
                }
            }
        },
    }
</script>